import { tokenFingerprint } from './operandiCaptureQueue';
import { operandiRetryRevision } from './operandiRetrySession';

const KEY = 'operandi-workflow-pending-v1';
const REVIEW_KEY = 'operandi-mapping-review-pending-v1';
const MAX_AGE = 24 * 60 * 60 * 1000;
function storage() {
  try { return window.sessionStorage; } catch { return null; }
}
function valid(request) {
  return request && ['question', 'answer', 'dispute', 'review_mapping'].includes(request.action) &&
    typeof request.command_id === 'string' && !!request.command_id &&
    typeof request.statement === 'string' && !!request.statement.trim() &&
    request.statement.length <= 2000 && Array.isArray(request.evidence_refs) &&
    request.evidence_refs.length <= 10 &&
    (request.action === 'review_mapping' ? typeof request.thread_id === 'string' && !!request.thread_id &&
      Number.isInteger(request.expected_version) && request.expected_version > 0 &&
      /^[a-f0-9]{64}$/.test(request.expected_input_hash) &&
      ['CHANGES_REQUIRED', 'VALIDATED', 'DISPUTED'].includes(request.decision)
      : request.action === 'question' ? typeof request.assigned_user_id === 'string' && !!request.assigned_user_id
      : Number.isInteger(request.expected_version) && request.expected_version > 0 &&
        typeof (request.action === 'answer' ? request.thread_id : request.target_context_id) === 'string');
}
export async function persistPendingWorkflow(request, scope, runId, key = KEY, isCurrent = () => true) {
  const revision = operandiRetryRevision();
  const fingerprint = await tokenFingerprint(scope?.token);
  if (!fingerprint || !scope?.orgId || !scope.locationId || !runId || !valid(request) ||
      (request.action === 'review_mapping') !== (key === REVIEW_KEY)) return false;
  try {
    const target = storage();
    if (!target || !isCurrent() || revision !== operandiRetryRevision()) return false;
    target.setItem(key, JSON.stringify({ version: 1, organization_id: scope.orgId,
      location_id: scope.locationId, token_fingerprint: fingerprint, run_id: runId,
      saved_at: Date.now(), request }));
    return true;
  } catch { return false; }
}
export async function loadPendingWorkflow(scope, runId, key = KEY) {
  const revision = operandiRetryRevision();
  try {
    const raw = storage()?.getItem(key);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    const fingerprint = await tokenFingerprint(scope?.token);
    if (revision !== operandiRetryRevision() || storage()?.getItem(key) !== raw) return null;
    if (saved.version !== 1 || !fingerprint || saved.token_fingerprint !== fingerprint ||
        saved.organization_id !== scope?.orgId || saved.location_id !== scope?.locationId ||
        typeof saved.run_id !== 'string' || !saved.run_id || !Number.isFinite(saved.saved_at) ||
        Date.now() < saved.saved_at || Date.now() - saved.saved_at >= MAX_AGE || !valid(saved.request) ||
        (saved.request.action === 'review_mapping') !== (key === REVIEW_KEY)) {
      if (storage()?.getItem(key) === raw) storage()?.removeItem(key);
      return null;
    }
    if (runId && saved.run_id !== runId) return null;
    return { runId: saved.run_id, request: saved.request };
  } catch { clearPendingWorkflow(undefined, key); return null; }
}
export function clearPendingWorkflow(commandId, key = KEY) {
  try {
    const target = storage();
    if (!commandId || JSON.parse(target?.getItem(key) || 'null')?.request?.command_id === commandId)
      target?.removeItem(key);
  } catch { /* Browser policy may disable tab storage. */ }
}
export const persistPendingMappingReview = (request, scope, runId, isCurrent) => persistPendingWorkflow(request, scope, runId, REVIEW_KEY, isCurrent);
export const loadPendingMappingReview = (scope, runId) => loadPendingWorkflow(scope, runId, REVIEW_KEY);
export const clearPendingMappingReview = commandId => clearPendingWorkflow(commandId, REVIEW_KEY);
